<app-banner-card data-testid="customer-details-banner" [breadcrumbs]="breadcrumbs">
  <app-content-container>
    <div class="flex justify-start items-center gap-4">
      @if (customer()) {
        <form [formGroup]="iconForm()" class="custom-form">
          <app-file-uploader
            class="w-full"
            size="small"
            shape="circle"
            [imageId]="iconForm().controls.iconId.value"
            [fileForm]="iconForm().controls.imageFile"
            [requiredPermission]="[EPermissions.customerUpdateOwn]"
            [isViewMode]="!(EPermissions.customerUpdateOwn | hasPermission)"
            (imageSelected)="onImageSelected($event)"
            (imageRemoved)="onImageRemoved()"
            #fileUploaderComponent
          />
        </form>
      } @else {
        <ngx-skeleton-loader
          class="h-[100px]"
          [theme]="{
            height: '100px',
            width: '100px',
            borderRadius: '100vw',
          }"
        />
      }

      <div class="flex justify-between w-full">
        <div class="flex flex-col gap-2 pt-2 pb-4 justify-between">
          <div class="flex items-center min-h-12">
            @if (isEditingName()) {
              <div class="flex items-center gap-2">
                <form [formGroup]="nameForm()" class="custom-form slim-field">
                  <mat-form-field class="w-72" [class.mb-4]="nameErrorMessage() && !nameForm().get('name')?.valid">
                    <input
                      #nameInput
                      matInput
                      data-testid="customer-name-input"
                      formControlName="name"
                      [placeholder]="'pages.customerDetails.namePlaceholder' | translate"
                      (keydown.Enter)="onSaveClick($event)"
                      (keydown.Escape)="onDiscardClick($event)"
                    />

                    @if (nameSaving()) {
                      <app-dots-spinner matSuffix />
                    }

                    <mat-error
                      [control]="nameForm().get('name')"
                      [customErrorMessage]="nameErrorMessage() || ''"
                      [positionAbsolute]="true"
                    />
                  </mat-form-field>
                </form>
                <div
                  class="flex items-center gap-2"
                  [class.mb-4]="nameErrorMessage() && !nameForm().get('name')?.valid"
                >
                  <button
                    mat-icon-button
                    type="button"
                    data-testid="customer-name-save"
                    class="mat-secondary-transparent-button-color"
                    [disabled]="nameSaving()"
                    (click)="onSaveClick($event)"
                  >
                    <app-icon src="/icons/check.svg" alt="save" class="w-3 h-3" />
                  </button>
                  <button
                    mat-icon-button
                    type="button"
                    data-testid="customer-name-discard"
                    class="mat-secondary-transparent-button-color"
                    [disabled]="nameSaving()"
                    (click)="onDiscardClick($event)"
                  >
                    <app-icon src="/icons/close.svg" alt="discard" class="w-3 h-3" />
                  </button>
                </div>
              </div>
            } @else if (customer()) {
              <h2 class="font-normal" data-testid="customer-details-banner-name">{{ customer()?.name ?? '' }}</h2>
            } @else {
              <ngx-skeleton-loader
                class="h-8"
                [theme]="{
                  height: '32px',
                  width: '172px',
                }"
              />
            }
          </div>

          <div class="flex items-center gap-1 min-h-6">
            @if (customer()?.createdAt) {
              <app-icon src="/icons/calendar.svg" alt="Date" [size]="16" />
              <span class="text-sm">{{ customer()?.createdAt | date: 'dd.MM.yyyy' }}</span>
            } @else if (!customer()) {
              <ngx-skeleton-loader
                class="h-5"
                [theme]="{
                  height: '20px',
                  width: '88px',
                }"
              />
            }
          </div>
        </div>

        <div class="flex items-start pt-2 gap-4">
          @if (!customer()) {
            <div class="flex items-center justify-center h-8 w-8">
              <ngx-skeleton-loader
                class="h-6"
                [theme]="{
                  height: '24px',
                  width: '24px',
                  borderRadius: '100vw',
                }"
              />
            </div>
          } @else {
            <button
              *hasPermission="[EPermissions.customerUpdateOwn]"
              mat-icon-button
              class="mat-big-icon-button"
              data-testid="customer-actions-menu-trigger"
              [matMenuTriggerFor]="menu"
              [class.mb-5]="isEditingName()"
            >
              <app-icon src="icons/edit.svg" alt="Three Dots Icon" [size]="24" />
            </button>
          }

          <mat-menu #menu="matMenu">
            <button
              *hasPermission="[EPermissions.customerUpdateOwn]"
              mat-menu-item
              data-testid="change-name-menu-item"
              (click)="onChangeNameClick()"
            >
              {{ 'shared.form.changeName' | translate }}
            </button>
            <button *hasPermission="[EPermissions.customerUpdateOwn]" mat-menu-item (click)="onChangeImageClick()">
              {{ 'shared.form.changeImage' | translate }}
            </button>
          </mat-menu>

          @if (!customer()) {
            <div class="flex items-center justify-center h-8 w-8">
              <ngx-skeleton-loader
                class="h-6"
                [theme]="{
                  height: '24px',
                  width: '24px',
                  borderRadius: '100vw',
                }"
              />
            </div>
          } @else if (!isEditingName()) {
            <button
              *hasPermission="[EPermissions.customerDeleteOwn]"
              mat-icon-button
              data-testid="delete-customer-button"
              class="mat-big-icon-button"
              (click)="onDeleteCustomerClick()"
            >
              <app-icon src="/icons/trash.svg" alt="Trash Icon" [size]="24" />
            </button>
          }
        </div>
      </div>
    </div>
  </app-content-container>
</app-banner-card>
